import type { FormLayout, FormLayoutPage } from '../../../../../forms'
import { BasicInfoLayout } from './basic-info'
import { buildLayoutWithCommonSections, layoutFields } from './helpers'
import { NotesLayout } from './notes'

const MachineRoomLayout: FormLayoutPage = {
  key: 'machine-room',
  title: 'Machine Room',
  contents: [
    layoutFields.speed,
    layoutFields.condition,
    layoutFields.accumulatedWear,
    layoutFields.design,
    layoutFields.inherentQuality,
    layoutFields.usage,
    layoutFields.environment,
    layoutFields.technology,
    layoutFields.typeOfUse,
    // TODO: On the original form this was called Power Unit Install Year, check with Daniel to see if this would be confusing to the user
    {
      ...layoutFields.drivingMachineInstallYear,
      label: 'Power Unit Install Year',
    },
    layoutFields.operationalControllerInstallYear,
    layoutFields.typeOfMotorController,
    layoutFields.hasFlexibleHose,
    layoutFields.hasMGSet,
    layoutFields.governorType,
    layoutFields.hasEmergencyPower,
    layoutFields.hasPressureVessel,
    layoutFields.isMachineRoomLess,
    layoutFields.hasPressureSwitch,
    layoutFields.hasBatteryLowering,
    layoutFields.execSoftwareRevision,
    layoutFields.controllerManufacturerAndModel,
    layoutFields.drivingMachineManufacturerAndModel,
    layoutFields.controlValveManufacturerModel,
    layoutFields.carsShareMachineRoom,
  ],
}

const CarTopLayout: FormLayoutPage = {
  key: 'car-top',
  title: 'Car Top',
  contents: [
    layoutFields.suspensionMembersInstallYear,
    layoutFields.interlocksInstallYear,
    layoutFields.typeOfDoorOperator,
    layoutFields.doorRestrictorType,
    layoutFields.hasCarSafeties,
    layoutFields.hasBrokenRopeSelectorSwitch,
    layoutFields.hasCounterWeights,
    layoutFields.hasCounterweightSafeties,
    layoutFields.guideType,
    layoutFields.doorOperatorManufacturerAndModel,
  ],
}

const InCarLayout: FormLayoutPage = {
  key: 'in-car',
  title: 'In Car',
  contents: [
    layoutFields.hoistwayDoorType,
    layoutFields.carDoorType,
    layoutFields.numLandings,
    layoutFields.numberOfOpenings,
    layoutFields.doorOpeningMethod,
    layoutFields.doorPanelsType,
    layoutFields.hasHoistwayAccess,
    layoutFields.hasFirefighterService,
    layoutFields.isObservationElevator,
    layoutFields.hasVisionPanels,
  ],
}

const PitLayout: FormLayoutPage = {
  key: 'pit',
  title: 'Pit',
  contents: [
    layoutFields.bufferType,
    layoutFields.hasBufferSwitches,
    layoutFields.hasOverspeedValve,
    layoutFields.hasPlungerGripper,
    layoutFields.hasCylinderCorrosionProtection,
    layoutFields.numCarsSharePit,
  ],
}

export const RopedHydraulicElevatorFormLayout: FormLayout =
  buildLayoutWithCommonSections([
    BasicInfoLayout,
    MachineRoomLayout,
    CarTopLayout,
    InCarLayout,
    PitLayout,
    NotesLayout,
  ])
